module.exports = __webpack_public_path__ + "img/Eric.cf67b99e.png";